import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/GridLegacy';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router';

import { PublicPackage } from '@drivingdoc/api-client/generated/types';

interface PropTypes {
  pkg: PublicPackage;
}

function Package({ pkg }: PropTypes): JSX.Element {
  return (
    <Grid item xs={12} md={4} key={pkg.id}>
      <Box component={Card} height={1} display={'flex'} flexDirection={'column'} boxShadow={pkg.isHighlighted ? 4 : 1}>
        <CardContent
          sx={{
            padding: 4,
          }}
        >
          <Box marginBottom={4} display={'flex'} flexDirection="column" gap={2} justifyContent={'space-between'}>
            <Typography variant={'h4'}>
              <Box component={'span'} fontWeight={600}>
                {pkg.title}
              </Box>
            </Typography>
            <Box display={'flex'} alignItems={'baseline'} alignSelf="flex-end">
              <Typography variant={'h4'} color={'primary'}>
                <Box component={'span'} fontWeight={600}>
                  {pkg.price}
                </Box>
              </Typography>
            </Box>
          </Box>
          <Grid container spacing={1}>
            {pkg.courses.map((course, j) => (
              <Grid item xs={12} key={j}>
                <Box component={ListItem} disableGutters width={'auto'} padding={0}>
                  <ListItemIcon sx={{ minWidth: 'unset', mr: 1 }}>
                    <CheckCircleIcon color="primary" />
                  </ListItemIcon>
                  <ListItemText primary={`${course.performance_time_included} of ${course.title}`} />
                </Box>
              </Grid>
            ))}
            {pkg?.services_included?.map((service, j) => (
              <Grid item xs={12} key={j}>
                <Box component={ListItem} disableGutters width={'auto'} padding={0}>
                  {/* <Box
                                        component={ListItemAvatar}
                                        minWidth={'auto !important'}
                                        marginRight={2}
                                    >
                                        <CheckCircleIcon sx={{ color: theme.palette.primary.main, p: 0 }} fontSize="medium" />
                                    </Box> */}
                  <ListItemIcon sx={{ minWidth: 'unset', mr: 1 }}>
                    <CheckCircleIcon color="primary" />
                  </ListItemIcon>
                  <ListItemText primary={service} />
                </Box>
              </Grid>
            ))}
          </Grid>
        </CardContent>
        <Box flexGrow={1} />
        <CardActions sx={{ justifyContent: 'flex-end', padding: 4 }}>
          <Button component={Link} to={`/package/${pkg.id}`} size={'large'} variant={'contained'}>
            Register
          </Button>
        </CardActions>
      </Box>
    </Grid>
  );
}

export default Package;
